<div class="loader">
  <lib-tb-modal [custom]="modalLoader">
    <div class="flex flex-col gap-4 items-center justify-center">
      <lib-tb-progress-spinner [custom]="spinnerLoader"></lib-tb-progress-spinner>
      <div class="grid justify-items-center items-center gap-2">
        <p class="text-primaryL100 text-xl font-semibold">Por favor, espere unos momentos</p>
        <p class="text-grayscaleWhite">Estamos validando su información.</p>
      </div>
    </div>
  </lib-tb-modal>
</div>
